import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import styled from 'styled-components';

import { ProductDuration } from 'utils/services/VervAPI';
import { useT } from '@hooks';
import { appStore } from '@store';

interface Props {
	periodText?: string;
	introPeriodText?: string;
	fullPriceText?: string;
	introPriceText?: string;
	currency?: string;
	withRenewalText?: boolean;
	duration?: ProductDuration;
	fullPrice?: number;
	introPrice?: number;
}

const Container = styled.div`
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: ${({ theme }) => theme.colors.text1};
	text-align: left;
	letter-spacing: -0.08px;
`;

const Description = styled.div`
	color: ${({ theme }) => theme.colors.text27};
`;

export const Agreements: FC<Props> = observer(props => {
	const { duration, fullPrice, introPrice } = props;
	const { T } = useT();
	const [periodText, setPeriodText] = useState('month');
	const [introPeriodText, setIntroPeriodText] = useState('month');
	const [fullPriceText, setFullPriceText] = useState('');
	const [introPriceText, setIntroPriceText] = useState('');
	const { product: paymentModal } = appStore.paymentStore;
	const [textValue, setTextValue] = useState(
		'By clicking GET MY PLAN, I agree to pay __fullPriceText__ for my plan and that if I do not cancel before the end of the __period__ introductory plan, it will convert to a __period__ subscription and Verv will automatically charge my payment method the regular price __fullPriceText__ every __period__ thereafter until I cancel. I can cancel online by visiting subscription page in my Verv app account to avoid being charged for the next billing cycle.',
	);

	useEffect(() => {
		if (paymentModal.details?.intro_amount) {
			setTextValue(
				'By clicking GET MY PLAN, I agree to pay __introPriceText__ for my plan and that if I do not cancel before the end of the __introPeriod__ introductory plan, it will convert to a __period__ subscription and Verv will automatically charge my payment method the regular price __fullPriceText__ every __period__ thereafter until I cancel. I can cancel online by visiting subscription page in my Verv app account to avoid being charged for the next billing cycle.',
			);
		} else {
			setTextValue(
				'By clicking GET MY PLAN, I agree to pay __fullPriceText__ for my plan and that if I do not cancel before the end of the __period__ introductory plan, it will convert to a __period__ subscription and Verv will automatically charge my payment method the regular price __fullPriceText__ every __period__ thereafter until I cancel. I can cancel online by visiting subscription page in my Verv app account to avoid being charged for the next billing cycle.',
			);
		}
	}, [paymentModal]);

	useEffect(() => {
		const durationToUse = duration ?? paymentModal.details?.duration;
		const trialPeriod = paymentModal.details?.trial_period_days || 0;

		if (durationToUse != null) {
			if (durationToUse.unit === 'month') {
				const periodTextMonth =
					(durationToUse.value ?? 0) > 1
						? durationToUse.value === 6
							? T('tariff_months_variable')
							: T('tariff_months')
						: T('tariff_month');
				setPeriodText(`${durationToUse.value ?? ''} ${periodTextMonth}`);
			} else {
				const periodTextWeek =
					(durationToUse.value ?? 0) > 1 ? T('tariff_weeks') : T('tariff_week');
				setPeriodText(`${durationToUse.value ?? ''} ${periodTextWeek}`);
			}
		}

		if (trialPeriod !== 0) {
			if (trialPeriod === 365) {
				setIntroPeriodText(`12 ${T('tariff_months_variable')}`);
			} else if (trialPeriod === 90) {
				setIntroPeriodText(`3 ${T('tariff_months_variable')}`);
			} else if (trialPeriod === 7) {
				setIntroPeriodText(`1 ${T('tariff_week')}`);
			} else {
				setIntroPeriodText(`1 ${T('tariff_month')}`);
			}
		}

		if (paymentModal.details?.amount) {
			setFullPriceText(`${props.currency ?? ''}${fullPrice ?? paymentModal.details.amount}`);
		}
		if (paymentModal.details?.intro_amount) {
			setIntroPriceText(
				`${props.currency ?? ''}${introPrice ?? paymentModal.details.intro_amount}`,
			);
		}
	});
	return (
		<Container>
			<Description
				dangerouslySetInnerHTML={{
					__html: textValue
						.replace(/__introPriceText__/g, props.introPriceText ?? introPriceText)
						.replace(/__introPeriod__/g, props.periodText ?? introPeriodText)
						.replace(/__period__/g, props.periodText ?? periodText)
						.replace(/__fullPriceText__/g, props.fullPriceText ?? fullPriceText),
				}}
			/>
		</Container>
	);
});
